import React from 'react';

type Props = {
  isLoading: boolean;
  loadMoreRef: React.RefObject<null>;
};

const LoadMore: React.FC<Props> = ({ isLoading, loadMoreRef }) => {
  return (
    <div className="mt-[5px]" ref={loadMoreRef}>
      {isLoading && (
        <div className="flex justify-center items-center p-4">
          <div className="h-6 w-6 animate-spin rounded-full border-4 border-gray-300 border-t-[#252525]"></div>
        </div>
      )}
    </div>
  );
};

export default LoadMore;
